import TableViewTab from "@organisms/Table/TableViewControls/TableViewTab/TableViewTab"
import TableViewTabs from "@organisms/Table/TableViewControls/TableViewTabs/TableViewTabs"

import { VENDOR_ROUTES } from "@routes/vendor"

export const VendorTableViewTabs = () => (
    <TableViewTabs>
        <TableViewTab
            id="all_active"
            phase="active"
            title="All Active"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["ordering", "name"],
                ["is_active", "true"],
            ]}
            listEndpoint={VENDOR_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={VENDOR_ROUTES.COUNT}
        />
        <TableViewTab
            id="all_inactive"
            phase="inactive"
            title="All Inactive"
            endpointKwargs={[
                ["ordering", "name"],
                ["is_active", "false"],
            ]}
            listEndpoint={VENDOR_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={VENDOR_ROUTES.COUNT}
            isDefaultActiveTabForPhase={true}
        />
    </TableViewTabs>
)
